import { combineReducers } from 'redux-immutablejs';
import globalReducer from './global';
import roleReducer from './role';
import usersReducer from './users';
import taxTransparencyReducer from './taxTransparency';
import publicPortalReducer from './publicPortal';
import websiteAdminReducer from './websiteAdmin';
import electronicCorrespondenceReducer from './electronicCorrespondence';

/**
 * The application's main reducer
 */
export default combineReducers({
  global: globalReducer,
  role: roleReducer,
  users: usersReducer,
  taxTransparency: taxTransparencyReducer,
  publicPortal: publicPortalReducer,
  websiteAdmin: websiteAdminReducer,
  electronicCorrespondence: electronicCorrespondenceReducer,
});
